import React from 'react';
import { Container } from 'react-bootstrap';
import styles from './footer.module.scss';
import LinksCol from './footer/links-col';
import Logo from './logo';
import { isMobileApp } from '@/app/general';

function Footer() {
  const col1Links = [
    {
      link: "/",
      title: "صفحه اصلی"
    },
    {
      link: "/contact",
      title: "ارتباط با ما"
    },
    {
      link: "/terms",
      title: "قوانین و مقررات"
    },
    {
      link: "/about",
      title: "درباره ما"
    },
    {
      link: "/faq",
      title: "سوالات متداول"
    },
  ];

  const col2Links = [
    {
      link: "/texts",
      title: "تکست ها"
    },
    {
      link: "/beats",
      title: "بیت ها"
    },
    {
      link: "/maquettes",
      title: "ماکت ها"
    },
    {
      link: "/studios",
      title: "استودیوها"
    },
    {
      link: "/artists",
      title: "آرتیست ها"
    },
  ];

  return (
    <footer className={styles.footer}>
      <Container>
        <div className="row">
          <div className={styles.col + " col-md-6 col-sm-8 mb-5"}>
            <div className={styles.header}>
              <Logo />
            </div>
            <div className={styles.body}>
              <h4>تکست نویس</h4>
              <p>جهت انجام پروژه های سفارشی با ما در ارتباط باشید.</p>
              <div className="row ltr text-end">
                <div className="col-sm-6">
                  <a href="mailto:info@textnevis.ir" className={"light-anchor " + styles.contactLink}><i className="fa fa-envelope text-primary me-2" /> info@textnevis.ir</a>
                </div>
                <div className="col-sm-6">
                  <a href="tel:+989382666208" className={"light-anchor " + styles.contactLink}><i className="fa fa-phone text-primary me-2" /> 0938 266 6208</a>
                </div>
              </div>
              <div className={styles.social}>
                <a href="https://www.instagram.com/textnevispro" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram" /></a>
                <a href="https://wa.me/989382666208" target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp" /></a>
                <a href="https://t.me/textnevisofficial" target="_blank" rel="noopener noreferrer"><i className="fab fa-telegram" /></a>
                <a href="https://www.facebook.com/textnevis_official" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook" /></a>
              </div>
            </div>
          </div>
          <LinksCol title="تکست نویس" icon="music" links={col1Links} />
          <LinksCol title="دسترسی سریع" icon="link" links={col2Links} />
        </div>
      </Container>
      <div className={styles.subFooter}>
        <div className={styles.copyright}>
          تمام حقوق مادی و معنوی این { isMobileApp() ? "اپلیکیشن" : "سایت" } متعلق به تکست نویس می باشد.
        </div>
        <div className={styles.developer}>
          {' طراحی و برنامه نویسی با '}
          <i className="fa fa-heart" />
          {' توسط '}
          <a href="https://tarbor.me" target="_blank" rel="noopener noreferrer" className="light-anchor">تربر</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
